export default {
    onsiteStatus: 'สถานะการไปนอกสถานที่',
    onsiteStatusMessage: 'ไม่มีการไปนอกสถานที่ของพนักงานในวันนี้',
    name: 'ชื่อ',
    group: 'กลุ่ม',
    submittedDate: 'วันที่ส่ง',
    status: 'สถานะ',
    period: 'ระยะเวลา'
}
